<div *ngIf="services" [ngClass]="{ 'mt-top-end-navbar': !isFromModal }" class="container-fluid">
	<div class="row justify-content-md-center">
		<div class="col-12">
			<!-- FTTH ACCESS -->
			<mat-card class="card border-0 shadow-sm">
				<div *ngIf="!isFromModal" class="media border-0">
					<a class="info" href="https://openfiber.it/it/fibra-ottica/occhio-al-bollino" target="_ftth">
						<img
							class="mr-3"
							src="{{ baseService.pathImgsMarkers }}/ftth.png?v={{ assets_version }}"
							alt="FTTH"
						/>
					</a>
					<div class="title-1">
						{{ "SERVICES_MENU.PON_ETHERNET" | translate }}
					</div>
				</div>

				<ng-container *ngFor="let service of services.ponServices">
					<div class="card-body border-0">
						<div class="title-2">
							{{ service.name }}
						</div>
						<div class="title-3">
							<span *ngIf="service.name.includes('Open Stream')">Open Stream Access (PON Ethernet)</span>
							<span *ngIf="service.name.includes('Open Internet')">Open Internet</span>
						</div>
						{{ service.description }}
						<div class="mt-3">
							<div class="title-4 mb-2">
								{{ "SERVICES.FEES" | translate }}
							</div>

							<!-- Price table -->
							<div *ngIf="!isFromModal" class="my-4 d-flex price-table">
								<div>
									<div class="table-box"></div>
									<div class="table-box table-title">NRC (Non Recurring Charge)</div>
									<div class="table-box table-title">MRC (Monthly Recurring Charge)</div>
								</div>
								<div>
									<div class="table-box table-title">Urban Area</div>
									<div class="table-box">€ {{ service.pricelists[0].prices.nrc }}</div>
									<div class="table-box">€ {{ service.pricelists[0].prices.mrc }}</div>
								</div>
								<div>
									<div class="table-box table-title">Rural Area</div>
									<div class="table-box">€ {{ service.pricelists[1].prices.nrc }}</div>
									<div class="table-box">€ {{ service.pricelists[1].prices.mrc }}</div>
								</div>
							</div>

							<div *ngIf="isFromModal">
								<ng-container *ngIf="buildingType === 'AB'">
									<ul>
										<li>
											{{ "SERVICES.NRC" | translate }}:
											<span class="bold">€ {{ service.pricelists[0].prices.nrc }}</span>
										</li>
										<li>
											{{ "SERVICES.MRC" | translate }}:
											<span>€ {{ service.pricelists[0].prices.mrc }}</span>
										</li>
									</ul>
								</ng-container>

								<ng-container *ngIf="buildingType === 'CD'">
									<ul>
										<li>
											{{ "SERVICES.NRC" | translate }}:
											<span class="bold">€ {{ service.pricelists[1].prices.nrc }}</span>
										</li>
										<li>
											{{ "SERVICES.MRC" | translate }}:
											<span>€ {{ service.pricelists[1].prices.mrc }}</span>
										</li>
									</ul>
								</ng-container>
							</div>

							<p class="vat">{{ "SERVICES.VAT_EXCLUDED" | translate }}</p>
						</div>
					</div>
				</ng-container>
			</mat-card>
		</div>
	</div>
</div>
